export default __webpack_public_path__ + "static/media/googleMap.91bee6a3.png";